import { toIsoDate } from "../lib/schedule";

export const routes = {
  login: "/login",

  task: {
    root: "/",
    create: "/work-orders/new",
    byId: (id: number | string) => `/tasks/${id}`,
    byUser: "/tasks",
    detail: (workOrderId: string) => `/work-orders/${workOrderId}`,
  },
  zeitmanagement: {
    root: "/zeitmanagement",
    create: "/zeitmanagement/new",
    edit: (id: string | number) => `/zeitmanagement/${id}/edit`,
  },
  aufgaben: {
    root: "/aufgaben",
    /**
     * Creating and editing a task is a modal on the list page, not a route of its own — the
     * state lives in the URL (`features/task-upsert`), so this is still a shareable deep link.
     */
    edit: (id: string | number) => `/aufgaben?upsert-task=edit&upsert-task-id=${id}`,
    plan: "/aufgaben/plan",
  },
  reschedule: {
    root: "/reschedule",
  },
  admin: {
    root: "/admin",
    mailSettings: "/admin/mail-settings",
  },

  users: {
    root: "/users",
    create: "/users/new",
    edit: (id: string | number) => `/users/${id}/edit`,
  },

  disposition: {
    root: "/disposition",
    /**
     * Planning mode on the board: arrive with something to place, click the slot, confirm in the
     * modal. Built here so no page hand-writes the query string — the params are read by
     * `widgets/disposition-board/model/useDispositionMode`.
     */
    planAppointment: (workOrderId: string) =>
      `/disposition?disposition-mode=schedule-appointment&work-order-id=${encodeURIComponent(workOrderId)}`,
    /**
     * Move an existing Termin: same mode and same slot pick, but the confirm opens the *edit* form
     * for that appointment instead of a create. Mirrors what `planTask(taskId)` does for a task.
     *
     * The Termin's own day is carried in `?day=`, so the board is right on the first paint rather
     * than opening on today and jumping once a query resolves. Callers have the date in hand — this
     * is the only place in the app that derives `?day=` from an entity.
     */
    rescheduleAppointment: (appointmentId: number, plannedWorkStartsAt: string) =>
      `/disposition?day=${toIsoDate(new Date(plannedWorkStartsAt))}` +
      `&disposition-mode=schedule-appointment&appointment-id=${appointmentId}`,
    /** Without an id the board plans a brand-new task on the picked slot. */
    planTask: (taskId?: number) =>
      `/disposition?disposition-mode=schedule-task${taskId != null ? `&task-id=${taskId}` : ""}`,
    /**
     * Move an Aufgabe that already holds a slot. Same mode and same `task-id` as `planTask` — the
     * board tells the two apart by whether the task has a `schedule` — but the day comes along, so
     * it opens where the Aufgabe actually is. Twin of `rescheduleAppointment`.
     */
    rescheduleTask: (taskId: number, plannedWorkStartsAt: string) =>
      `/disposition?day=${toIsoDate(new Date(plannedWorkStartsAt))}` +
      `&disposition-mode=schedule-task&task-id=${taskId}`,
  },

  auth: {
    forgotPassword: '/forgot-password',
    resetPassword: '/reset-password',
  },

  workerZeitmanagement: {
    edit: (id: string | number) => `/worker/zeitmanagement/${id}/edit`,
  },

  worker: {
    calendar: '/worker/calendar',
    privatzeit: '/worker/privatzeit',
    appointment: (id: string | number) => `/worker/appointments/${id}`,
    task: (id: string | number) => `/worker/tasks/${id}`,
  },

  controlling: {
    root: '/controlling',
  },
};
